import { render, staticRenderFns } from "./compLoader.vue?vue&type=template&id=e0e13f1e&scoped=true&"
var script = {}
import style0 from "./compLoader.vue?vue&type=style&index=0&id=e0e13f1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e13f1e",
  null
  
)

export default component.exports